// extracted by mini-css-extract-plugin
export default {"fade":"Modal_fade__eIQVS","modal":"Modal_modal__c0QA9"};